var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-input-group",
    [
      _c("b-form-input", {
        ref: "input",
        attrs: {
          value: _vm.value,
          type: _vm.type,
          required: _vm.required,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder,
          autocomplete: _vm.autocomplete
        },
        on: { input: _vm.changed }
      }),
      _vm._v(" "),
      _c(
        "b-input-group-append",
        [
          _c(
            "b-btn",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.hover.leftbottom",
                  modifiers: { hover: true, leftbottom: true }
                }
              ],
              ref: "generatePasswordButton",
              class: _vm.$style["outline-input-special"],
              attrs: { disabled: _vm.disabled, title: "Генерировать пароль" },
              on: {
                click: function($event) {
                  return _vm.generate()
                }
              }
            },
            [_c("i", { staticClass: "far fa-key" })]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }